<div class="event-line" [class.event-line--excluded]="excluded()">
	<mat-checkbox
		class="event-count-checkbox"
		[checked]="!excluded()"
		[disabled]="disabled()"
		(change)="onCountedChange($event.checked)"
		[matTooltip]="countTooltip()"
		matTooltipPosition="above"
		aria-label="Liczyć do rozliczenia"
	></mat-checkbox>
	<a class="event-dates" [routerLink]="['/tourism-events', eventId()]">
		{{ dateFrom() | date: 'd MMM, HH:mm' }}
		<span class="event-dash">–</span>
		{{ dateTo() | date: 'd MMM, HH:mm' }}
	</a>
	@if (isMultiMonth()) {
		<span class="settlement-badge settlement-badge-period" [matTooltip]="periodTooltip()">
			Okres {{ monthSpan().index }}/{{ monthSpan().total }}
		</span>
	}
	<span class="event-amount" [class.event-amount--excluded]="excluded()">
		<ng-content></ng-content>
	</span>
	@if (excluded()) {
		<span class="settlement-badge settlement-badge-excluded">Wykluczone</span>
	}
</div>
<p class="event-source" [class.event-source--missing]="nawigatorEventId() === null">
	@if (nawigatorEventId() !== null) {
		ID Nawigator: <span class="event-source__id">{{ nawigatorEventId() }}</span>
	} @else {
		<span
			matTooltip="Wydarzenie nie jest powiązane z wierszem harmonogramu Nawigatora, więc synchronizacja go nie aktualizuje ani nie usuwa."
			matTooltipPosition="above"
			>Brak powiązania z Nawigatorem</span
		>
	}
</p>
@if (isMultiMonth() && flatRate() && !excluded()) {
	<p class="event-flat-warning">
		<mat-icon class="event-flat-warning__icon"><i class="fa-solid fa-triangle-exclamation"></i></mat-icon>
		Ryczałt naliczany w każdym z {{ monthSpan().total }} okresów tego wydarzenia. Odznacz pozostałe okresy, jeśli ma
		zostać rozliczony tylko raz.
	</p>
}
@if (excluded() || commentValue()) {
	<mat-form-field appearance="outline" class="event-comment-field" subscriptSizing="dynamic">
		<mat-label>Powód wykluczenia (opcjonalnie)</mat-label>
		<input
			matInput
			maxlength="500"
			[disabled]="disabled()"
			[ngModel]="commentValue()"
			(ngModelChange)="onCommentInput($event)"
		/>
	</mat-form-field>
}
